import React from "react"
import Section from "../blocks/section"
import DfbButton from "../ui-kit/dfb_button"

type CardCtaItem = {
  card_cta_headline: string;
  card_cta_description: string;
  card_cta_alternative: string;
  card_cta_link: string;
}

type ComparisonItem = {
  comparison_headline: string;
  comparison_description: string;
  comparison_check1: string;
  comparison_text1: string;
  comparison_check2: string;
  comparison_text2: string;
  comparison_check3: string;
  comparison_text3: string;
}

function MComparisonTable({ data }: {
  data: {
    headline: string,
    card_cta_item: CardCtaItem[],
    comparison_item: ComparisonItem[]
  } & Record<string, string>
}) {
  const {headline, card_cta_item, comparison_item} = data
  return (
    <Section baseClass="m-MatrixTable" data={data} defaultPadding="small">
      <div className="m-MatrixTable-wrapper">
        <div className="m-MatrixTable-container">
          <div className="m-MatrixTable-content">
            <h2 className="dfb-Headline dfb-Headline--h2 m-MatrixTable-headline">
              {headline}
            </h2>
            <div className="m-MatrixTable-table">
              <div className="m-MatrixTable-table-inner">
                <div className="m-MatrixTable-table-inner-content">
                  <div className="m-MatrixTable-table-row m-MatrixTable-table-row-header m-MatrixTable-table-row-header--withSubnavigationTop">
                    <div className="m-MatrixTable-table-row-header-empty"></div>
                    <div className="m-MatrixTable-table-row-variant-row">

                      {card_cta_item?.map(item => (
                        <div className="m-MatrixTable-table-row-cell">
                          <div className="m-MatrixTable-table-row-header-content">
                            <h3>{item.card_cta_headline}</h3>
                            <p>{item.card_cta_description}</p>
                            <div className="m-MatrixTable-table-row-header-content-comparison">
                              <DfbButton
                                tagName="a"
                                text={item.card_cta_alternative}
                                link={item.card_cta_link}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>

                  {comparison_item?.map(item => (
                    <div className="m-MatrixTable-table-row">
                      <div className="m-MatrixTable-table-row-title">
                        <div className="m-MatrixTable-table-row-title-content">{item.comparison_headline}{item.comparison_description && ( <span>{item.comparison_description}</span>)}</div>
                      </div>
                      <div className="m-MatrixTable-table-row-variant-row">
                        <div className="m-MatrixTable-table-row-cell">
                          <div>{item.comparison_check1 === 'yes' ? '✔' : '▬'}</div>
                          <div>{item.comparison_text1}</div>
                        </div>
                        <div className="m-MatrixTable-table-row-cell">
                          <div>{item.comparison_check2 === 'yes' ? '✔' : '▬'}</div>
                          <div>{item.comparison_text2}</div>
                        </div>
                        <div className="m-MatrixTable-table-row-cell">
                          <div>{item.comparison_check3 === 'yes' ? '✔' : '▬'}</div>
                          <div>{item.comparison_text3}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MComparisonTable